import { isPlatformServer } from '@angular/common';
// type-coverage:ignore-next-line
import { computed, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BaseHttpService } from '@libraries/base-http/base-http.service';
import { OpenSourceMask, OpenSourceProject, OpenSourceProps } from './open-source.types';

@Injectable()
export class OpenSourceService {
    private readonly http = inject(BaseHttpService);
    private readonly date: Date = new Date();
    private readonly platformId = inject<string>(PLATFORM_ID);
    private readonly homeAssetPathOpenSource = 'content/home/open-source';

    public readonly projects: OpenSourceProject[] = [
        {
            title: 'Ngx Loader Indicator',
            text: 'Awesome loader for Angular applications. No wrappers only your elements',
            img: 'fingerprint',
            url: 'ngx-loader-indicator',
            rate: 0,
        },
        {
            title: 'Ngx Copypaste',
            text: 'A pure and awesome copy paste directive for Angular',
            img: 'hand',
            url: 'ngx-copypaste',
            rate: 0,
        },
    ];

    public readonly ngxMaskProps: OpenSourceMask[] = [
        {
            icon: `${this.homeAssetPathOpenSource}/depends`,
            value: 155,
            text: 'Packages depends',
            path: '',
            key: '',
        },
        {
            icon: 'shared/github',
            value: 0,
            text: 'github stars',
            path: 'https://api.github.com/repos/JsDaddy/ngx-mask',
            key: 'stargazers_count',
        },
        {
            icon: `${this.homeAssetPathOpenSource}/download-per-month`,
            value: 0,
            text: 'downloads per month',
            path: `https://api.npmjs.org/downloads/point/last-month/ngx-mask`,
            key: 'downloads',
        },
        {
            icon: `${this.homeAssetPathOpenSource}/downloads`,
            value: 0,
            text: 'downloads',
            path: `https://api.npmjs.org/downloads/point/2017-01-01:${this.date.getFullYear()}-${this.setNullToDate(
                this.date.getMonth() + 1
            )}-${this.setNullToDate(this.date.getDate())}/ngx-mask`,
            key: 'downloads',
        },
    ];

    private readonly isServer = isPlatformServer(this.platformId);

    private readonly propsResources = this.isServer
        ? []
        : this.ngxMaskProps.map((prop) =>
              prop.path
                  ? this.http.getResource<OpenSourceProps>(prop.path, {
                        stargazers_count: 0,
                        downloads: 0,
                    })
                  : null
          );

    private readonly projectResources = this.isServer
        ? []
        : this.projects.map((project) =>
              this.http.getResource<{ stargazers_count: number }>(
                  `https://api.github.com/repos/JsDaddy/${project.url}`,
                  { stargazers_count: 0 }
              )
          );

    public readonly propsList = computed(() => {
        if (this.isServer) {
            return this.ngxMaskProps;
        }
        return this.ngxMaskProps.map((prop, i) => {
            const resource = this.propsResources[i];
            if (!resource) {
                return prop;
            }
            const data = resource.value();
            if (!data) {
                return prop;
            }
            // type-coverage:ignore-next-line
            return { ...prop, value: data[prop.key as keyof OpenSourceProps] as number };
        });
    });

    public readonly projectsList = computed(() => {
        if (this.isServer) {
            return this.projects;
        }
        return this.projects.map((project, i) => {
            const resource = this.projectResources[i];
            if (!resource) {
                return project;
            }
            const data = resource.value();
            if (!data) {
                return project;
            }
            return { ...project, rate: data.stargazers_count };
        });
    });

    private setNullToDate(date: number): number | string {
        if (date < 10) {
            return `0${date}`;
        }
        return date;
    }
}
